import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import cn from 'classnames'

import styles from './StudentListItem.scss'

class StudentListItem extends PureComponent {

	render() {
		return (
			<div styleName={
				cn({
					StudentListItem: true,
					'StudentListItem--finished': this.props.finished,
				})
			}>
				<span styleName="StudentListItem-student">
					{this.props.name}
				</span>
				<span styleName="StudentListItem-matches">
					{this.props.tries !== 0 ? `${this.props.matches}/${this.props.totalPairs}` : '-'}
				</span>
				<span styleName="StudentListItem-tries">
					{this.props.tries !== 0 ? this.props.tries : '-'}
				</span>
			</div>
		)
	}
}

StudentListItem.propTypes = {
	finished: PropTypes.bool.isRequired,
	name: PropTypes.string.isRequired,
	matches: PropTypes.number,
	tries: PropTypes.number,
	totalPairs: PropTypes.number,
}

export default CSSModules(StudentListItem, styles, { allowMultiple: true })
